import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { CustomRouteReuseStrategy } from './core/custom-route-reuse-strategy';
import { MaterialModule } from '../app.material';
import { authProviders } from './pilotpay/pilotpay-routing.module';
import { IdentityAuthCallbackGuard } from './identity/guards/auth-callback.guard';
import { IdentityAuthGuard } from './identity/guards/auth.guard';

export const appRoutes: Routes = [
	{
		path: 'auth-callback',
		canActivate: [IdentityAuthCallbackGuard],
		children: []
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: '/pilotpay'
	},
	{
		path: 'login',
		pathMatch: 'full',
		redirectTo: '/pilotpay'
	},
	{
		path: 'pilotpay',
		canActivate: [IdentityAuthGuard],
		loadChildren: () => import('./pilotpay/pilotpay.module').then(m => m.PilotpayModule)
	}
];

/**
 * Routing Module
 */
@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
		FormsModule,
		CommonModule,
		HttpClientModule,
		MaterialModule
	],
	exports: [RouterModule],
	providers: [authProviders, { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }]
})

/**
 * Routing Module
 */
export class AppRoutingModule {}
